var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBevelMobile = function SvgBevelMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 12.44V26.68H20.25V15.83L16.86 12.44H6ZM22.09 6H12.1L6.86 11.24H16.86L22.09 6ZM21.45 15.83V25.83L26.69 20.59V10.58L21.45 15.83ZM26.43 9.14 25.41 8.12 24.99 7.7 24.56 7.27 23.54 6.25 18.55 11.24 17.95 11.84 18.55 12.44 20.25 14.13 20.85 14.73 21.45 14.13 26.43 9.14Z"
  })));
};
export default SvgBevelMobile;